export class Recipient {
    $id: number;
    CourseList?: string[];
    Email: string;
    FirstName: string;
    GradeLevel?: any;
    Id: number;
    LastName: string;
    MiddleName: string;
    Name: string;
    NickName: string;
    Relationship: string;
    Section?: string;
    SiteYearID: number;
    StudentContacts?: any;
    StudentNumber?: any;
    SubjectCode?: string;
    SubjectSections?: any;
    TeacherName: string;
    Term?: string;
    UserType: number;
    RelationshiptCourseList?: string[];
}